<div class="header" (click)="toggle()"
     [ngClass]="{'collapsible': isCollapsible, 'active': isActive}">
    <div class="header-control-before">
        <ng-content select="fui-content-layout-header-control[slot=before]"></ng-content>
    </div>
    <div class="header-label">
        @if (isInvalid) {
            <div class="header-label-media">
                <fui-icon class="header-label-media-object error" [height]="12" [icon]="'error'"
                          [width]="12"></fui-icon>
            </div>
        }
        <div class="header-label-title">
            {{ title | translate }}
        </div>
    </div>
    <div class="header-control-after">
        <ng-content select="fui-content-layout-header-control[slot=after]"></ng-content>
    </div>
    @if (isCollapsible) {
        <div class="header-action">
            <div class="header-action-media">
                <fui-icon class="header-action-media-object"
                          [ngClass]="{'active': isActive}"
                          [width]="12" [height]="8" [icon]="'chevron-down'"></fui-icon>
            </div>
        </div>
    }
</div>
@if (hasLoaded || !isCollapsible) {
    <div class="main" [hidden]="!isActive && isCollapsible">
        <ng-content></ng-content>
    </div>
}
